import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { corporateClientsAPI } from "api/api/corporateClientsApi/corporateClientsApi";
import { GetCorporateClientsByMarathonIdParams, GetCorporateClientsByMarathonIdRes } from "api/api/corporateClientsApi/types";

export const getCorporateClientsByMarathonId = createAsyncThunk<
  GetCorporateClientsByMarathonIdRes,
  GetCorporateClientsByMarathonIdParams
>(
  `statuses/getCorporateClientsByMarathonId`,
  async (params, { rejectWithValue }) => {
    try {
      const data = await corporateClientsAPI.getCorporateClientsByMarathonId(params);
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting statuses comments",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting statuses comments", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
